"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AWS_TOKEN_HEADER = exports.LOCAL_CLIENT_DEFAULT_PORT = void 0;
exports.LOCAL_CLIENT_DEFAULT_PORT = "2773";
exports.AWS_TOKEN_HEADER = "X-Aws-Parameters-Secrets-Token";
//# sourceMappingURL=constants.js.map